export const config = {
	reCaptchaSiteKey: "6LdVepcUAAAAAC9jzpl4-6RLLMMyh17ct9DAfibl"
};
